export default function CompassHint({ show, denied, onTap }) {
  if (!show) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={onTap}
      className="absolute left-1/2 top-[44%] z-20 max-w-[70%] -translate-x-1/2 -translate-y-1/2 rounded-lg border border-primary/35 px-3 py-2 text-center text-[0.82rem] leading-snug text-dark-muted backdrop-blur-[8px] transition-colors hover:border-accent-400/70 hover:text-dark-text"
      style={{ background: 'rgba(15,15,15,0.82)' }}
    >
      {denied ? 'Motion access needed — enable in Settings' : 'Tap to start compass'}
    </button>
  );
}
